export const MAX_COMPARE_SIZE = 4;
export const DESKTOP_DEVICE = 'desktop';
export const MOBILE_DEVICE = 'mobile';
export const NAVIGATION_MENU_HEIGHT = 101;
export const SUB_NAVIGATION_MENU_HEIGHT = 49;
export const VEHICLE_PATH_NAME = 'veh';
export const vehicleRegExp = new RegExp(`^${VEHICLE_PATH_NAME}[1-${MAX_COMPARE_SIZE}]$`);
export const COMPARATOR_PATHNAME = '/car-comparisons/';
export const MM_VS_MM_LINKS_SECTION_ID = 'make-model-vs-make-model';
export const NAV_LIST_CUSTOM_EVENT = 'comparator.nav_list';
